import React from 'react';
import styles from '../Operations.module.css';

interface MGIRComponent extends React.FC {
  title?: string;
  kpiHyperlink?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * MGIR - IRA
 * KPI information component
 */
const MGIR: MGIRComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Inventory record accuracy is the degree to which the actual quantity for each item in the store matches the quantity shown in the computer.<br/><br/>
        Inventory Record Accuracy (IRA) is a measure of quantity-on-hand accuracy in your store and is derived from <strong>completing Count Sheets monthly</strong>.<br/><br/>
        Your goal is to sustain 80% (8 out of 10 quantity-on-hands match the computer) or better.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        <table style={{ borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th scope="col" style={{ padding: '4px 32px 0 0', fontWeight: 'bold', textAlign: 'left' }}>Inventory Record Accuracy</th>
              <th scope="col" style={{ padding: '4px 0 0 0', fontWeight: 'bold', textAlign: 'left' }}>(IRA) % Accuracy Level</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: '4px 32px 0 0', fontWeight: 'bold' }}>90% or higher</td>
              <td style={{ padding: '4px 0 0 0', fontWeight: 'bold' }}>Extremely Accurate</td>
            </tr>
            <tr>
              <td style={{ padding: '4px 32px 0 0', fontWeight: 'bold' }}>85-89%</td>
              <td style={{ padding: '4px 0 0 0', fontWeight: 'bold' }}>Very Accurate</td>
            </tr>
            <tr>
              <td style={{ padding: '4px 32px 0 0', fontWeight: 'bold' }}>80-84%</td>
              <td style={{ padding: '4px 0 0 0', fontWeight: 'bold' }}>Moderately Accurate</td>
            </tr>
            <tr>
              <td style={{ padding: '4px 32px 0 0', fontWeight: 'bold' }}>75-79 %</td>
              <td style={{ padding: '4px 0 0 0', fontWeight: 'bold' }}>Poor accuracy</td>
            </tr>
            <tr>
              <td style={{ padding: '4px 32px 0 0', fontWeight: 'bold' }}>74% and below</td>
              <td style={{ padding: '4px 0 0 0', fontWeight: 'bold' }}>Very poor accuracy</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        80% or better
      </div>

      <div className={styles.sectionTitle}>
        Drill Down
      </div>

      <div className={styles.sectionContent}>
        13-Month Chart of History. For further information on IRA Calculations, review <a href="https://acenet.aceservices.com/awor/inventory-record-accuracy/achieving-inventory-accuracy" target="_blank" rel="noopener noreferrer" className={styles.link}>Level 1- IRA Help</a>.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        See Ace Way of Retailing (AWOR) <a href="https://acenet.aceservices.com/awor/inventory-record-accuracy/achieving-inventory-accuracy" target="_blank" rel="noopener noreferrer" className={styles.link}>Achieving Inventory Accuracy</a> document for instructions on how to set the foundation for achieving and maintaining inventory accuracy.
      </div>
    </div>
  );
};

MGIR.title = 'Inventory Record Accuracy';
MGIR.kpiHyperlink = 'https://mangoreport.com/radira';
MGIR.actionTitle = '';
MGIR.actionHyperlink = '';
export default MGIR;

